<script setup lang="ts">
  import { computed } from "vue";
  import { formatCount } from "@/utils/formatters";

  const props = withDefaults(
    defineProps<{ value: number; total: number; barClass?: string; barColor?: string; hideBar?: boolean }>(),
    { barClass: "bg-status-success", barColor: undefined, hideBar: false },
  );

  const pct = computed(() => (props.total > 0 ? Math.min(100, Math.round((props.value / props.total) * 100)) : 0));
</script>

<template>
  <span class="flex items-center gap-2.5">
    <span
      v-if="!props.hideBar"
      class="h-1 w-28 shrink-0 overflow-hidden rounded-full bg-secondary">
      <span
        class="block h-full rounded-full transition-[width] duration-300"
        :class="props.barColor ? undefined : props.barClass"
        :style="{ width: `${pct}%`, backgroundColor: props.barColor }" />
    </span>
    <span
      v-else
      class="w-28 shrink-0" />
    <span class="min-w-0 flex-1 text-right tabular-nums whitespace-nowrap">
      <slot>
        <span class="font-semibold text-primary">{{ formatCount(props.value) }}</span>
        <span class="text-foreground-subtle"> / {{ formatCount(props.total) }}</span>
      </slot>
    </span>
  </span>
</template>
